module.exports = __webpack_public_path__ + "static/opening-92bfe0870992d9cd8574cd60105e642d.png";